import React from 'react';
import HeaderNavbar from '../../BybMainPage/BybNavbar/HeaderNavbar';
import { WHATSAPP_CHATBOT_URL } from '../../../constants/whatsapp';

export default function SelfAuditHeaderNavbar(props) {
  return <HeaderNavbar {...props} contactUrl={WHATSAPP_CHATBOT_URL} />;
}